import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  createProjectStrategicAxis(
    request: Boundaries["createProjectStrategicAxis"]["request"],
  ): void;
}

function useCreateProjectStrategicAxis(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isCreateProjectStrategicAxisRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isCreateProjectStrategicAxisRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isCreateProjectStrategicAxisRequestFailure,
    ),
    createProjectStrategicAxis: core.createProjectStrategicAxis,
  };
}

export { useCreateProjectStrategicAxis };
